import JSEncrypt from "jsencrypt";
/**
 * 公钥加密（RSA非对称加密）
 * @param       str 要加密的密码
 * @return      加密后的密文
 * */
export function encodeRSA(str) {
    // 公钥
    const pubKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApt97bhK6E8b1ViLzNVJf8+UrBAkVYpvOV3bE1YZAhVwVuuUYtX06kUq/1aNvTRSrhFOJ5pgP7rfcFfCNhw7A1P764qv+cODcphyx7+aGkYNzgiB7fgFOnxAM/Yxo540Vj0KgPt4wpWLowVG6EpyifetFJ6+bHRRzwSGb9peFcN0Kj4qjypI6Vvl0RnwJ63xNOAdVvBEg3pghI8UUCuoJ7d5iQSI/tD33nTWhQ3wHm/zTYnCc2ZFcC+cdh/V8cx6cgsuLk9JPysY4UJYruGDrxBDFW26Z7/HFEu1zLzbA6ZOZkgeQj2il4mSyY9/qdrayMJlQcoaWGsPbgn4gxgtDSwIDAQAB`;
    const encryptStr = new JSEncrypt({
        default_key_size: "2048",
    });
    // 设置 加密公钥
    encryptStr.setPublicKey(pubKey);
    // 进行加密
    const encrypted = encryptStr.encrypt(str);
    // 处理加密失败的情况
    if (encrypted === false) {
        throw new Error("RSA加密失败，请检查公钥和输入内容");
    }
    return encrypted;
}
/**
 * 私钥解密（RSA非对称加密）
 * @param       ciphertext 密文
 * @return      解密后的字符串
 * */
export function decodeRSA(ciphertext) {
    var decrypt = new JSEncrypt({
        default_key_size: "2048",
    });
    var PRIVATE_KEY = "MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCm33tuEroTxvVWIvM1Ul/z5SsECRVim85XdsTVhkCFXBW65Ri1fTqRSr/Vo29NFKuEU4nmmA/ut9wV8I2HDsDU/vriq/5w4NymHLHv5oaRg3OCIHt+AU6fEAz9jGjnjRWPQqA+3jClYujBUboSnKJ960Unr5sdFHPBIZv2l4Vw3QqPiqPKkjpW+XRGfAnrfE04B1W8ESDemCEjxRQK6gnt3mJBIj+0PfedNaFDfAeb/NNicJzZkVwL5x2H9XxzHpyCy4uT0k/KxjhQliu4YOvEEMVbbpnv8cUS7XMvNsDpk5mSB5CPaKXiZLJj3+p2trIwmVByhpYaw9uCfiDGC0NLAgMBAAECggEAQ4YU9QKA5zXP2o4D6eSuTQvDbzuZurAfO8ckeN59Rzlu1ZSUfgPxag9cNr+ObxtZGA+Rsox/jfI6DWqsaiUvJEEVFhnQuK5UuqbL3a5jb4hIejRYpDE1NioRh5uEa4XsXm7wVuAjwRiX5HoEmDlnixpjfl6Rnp/DAzhtWsgPSA6P32VwbQ9lcO3YsBvJihi/RdYQjsaBjf1NWnziV0uGowAwCduOM8ompxds25D+6JTrIz/tZmwa/GcJZgh880BQDX9hjQc2XCANHkO6HRxQwhY3J0v/7umOfS4PBFt40EDOMgqWbwYzDTB1wPQKqRyNe63wurqSwtx34ZMzegRqQQKBgQD1CPRFiwbWMXcV/FZTXPyz1WXGf5/WUQ5sXDOxfXr7bVbnz4kDhY+COBKNLv2bd29iY5/qFEqeGoKRDHtFI6u2sSO46X7DO0IZvmjHo/VdFdfGsRa/IvKiAsUyox2IpoV9OmZzLQAUrFy2HqCXfBcUqOqJsL17UcSd438jz5MTKwKBgQCuVyDDBoXzkw3MAGjdrub+Zy8sAoB7ihVXENrKn+lsrRTkMmk1ZIPww46FmtK2Ojxf1u0wZbY+vn1oiD2I2wkGfPOy1/XlqxyBq5sjLl/ICZo9y0d/4C7XKRiy0iOnTHOcyuw0VZyM5GgCR9YiV+mVg/FXueLYfZxpPp/zCXMAYQKBgQCp5gCBK6mc4IVisCkm+iWZh5Be9uTb1C39Al0xZwDbzm9goeytjXD46GosjHV503FethcOVe16/ISlkBL02IvaS66qKvQi6Dan5Pd/3XZmiZuof+d2tgOoQ+V5e9Ihityp/NFGcOBKdUx/VnMhNgBG6exddjebhxGeLDxelzGyKwKBgD8Zedocek72Yn/7hfj2XNSnNAORxD7yc1bX2tiLmEilPHJ7bGjOwJJbtTHWH32lBkUJ3T8vEQ8Ukv9KkDsAS/v1LZ8FWxKNI/wqyDOrjS8xionjETXPRiTJ0w6l0BG1MgMFzwgCFG9KG/r3VSGJABoFb0x5EwmYLQxKhknImb8BAoGAYaTQuAH0iKQj6pLBTfj0BLR0gdZFweinSYsYWWLfeG54b3jsec1JbxzMHGOkNCxEtPb8hKocz7SRyGzE5ZTeB875vfxwum4/VX4sV6AIBEeKzteMZpUfVVrUOFGB4n548ELTtHC9CPM75Kg+AnNLlrABSq93dcHIAQ61SE0le4c=";
    // 设置 解密私钥
    decrypt.setPrivateKey(PRIVATE_KEY);
    //解密
    return decrypt.decrypt(ciphertext) || "";
}
